import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=4813c238&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4813c238')) {
      api.createRecord('4813c238', component.options)
    } else {
      api.reload('4813c238', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=4813c238&", function () {
      api.rerender('4813c238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/Document.vue"
export default component.exports